<template>
  <div class="ps-combobox">
    <div v-if="label" class="pb-2">{{ $t(label) }}</div>
    <v-combobox
      v-model="model"
      :items="items"
      :multiple="multiple"
      :chips="chips"
      :clearable="clearable"
      :dense="dense"
      :outlined="outlined"
      :disabled="disabled"
      :hide-details="hideDetails"
      :error-messages="errorMessages"
      :small-chips="smallChips"
      :placeholder="placeholder"
      clear-icon="fal fa-times"
      color="primary"
      class="primary--text"
      @change="onChange"
    >
    </v-combobox>
  </div>
</template>

<script>
export default {
  props: {
    value: {},
    items: { type: Array, default: () => [] },
    label: { type: String, required: true },
    errorMessages: { type: Array, default: () => [] },
    outlined: { type: Boolean, default: true },
    dense: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    multiple: { type: Boolean, default: false },
    chips: { type: Boolean, default: false },
    smallChips: { type: Boolean, default: false },
    clearable: { type: Boolean, default: false },
    placeholder: { type: String, default: "" },
    autoSave: { type: Boolean, default: false },
    optionName: { type: String, default: "" },
  },
  data() {
    return {
      model: this.value,
    };
  },
  watch: {
    value(newVal, oldVal) {
      if (newVal !== oldVal) this.model = newVal;
    },
    model(newVal, oldVal) {
      if (newVal !== oldVal) this.$emit("input", newVal);
    },
  },
  methods: {
    onChange(newValue) {
      if (this.autoSave && this.optionName && newValue) {
        // Handle both single values and arrays
        if (Array.isArray(newValue)) {
          // For arrays, check each value
          const newValues = newValue.filter((val) => !this.items.includes(val));
          if (newValues.length > 0) {
            this.$emit("new-value", {
              optionName: this.optionName,
              value: newValues,
            });
          }
        } else {
          // For single values
          if (!this.items.includes(newValue)) {
            this.$emit("new-value", {
              optionName: this.optionName,
              value: newValue,
            });
          }
        }
      }
    },
  },
  computed: {
    hideDetails() {
      if (this.errorMessages && this.errorMessages.length) {
        return false;
      }
      return true;
    },
  },
};
</script>

<style></style>
